export const getRowKeyValue = (record, rowKey) =>
  typeof rowKey === 'function' ? rowKey(record) : record?.[rowKey];

// A group can only be expanded when it has items to show.
export const hasGroupItems = (group, itemsKey = 'items') =>
  (group?.[itemsKey] || []).length > 0;

// Keys of the groups expanded when the table loads or changes page. When
// `itemsKey` is given, groups without items are never expanded.
export const getInitialExpandedKeys = (
  groups = [],
  rowKey,
  mode = 'none',
  itemsKey = null
) => {
  const expandableGroups = itemsKey
    ? groups.filter((group) => hasGroupItems(group, itemsKey))
    : groups;
  if (mode === 'all')
    return expandableGroups.map((group) => getRowKeyValue(group, rowKey));
  if (mode === 'first' && expandableGroups.length > 0) {
    return [getRowKeyValue(expandableGroups[0], rowKey)];
  }
  return [];
};
